<template>
  <club-layout>
    <blue-panel-date-time-picker @apply="onApply" />
    <div id="container">
      <table-blue-club-transfers :transfers="clubTransfers" />
    </div>
  </club-layout>
</template>

<script>
  import { mapActions, mapGetters, mapMutations } from 'vuex';
  import TableBlueClubTransfers from './tables/TableBlueClubTransfers.vue';

  export default {
    name: 'ClubTransfersPage',
    components: {
      TableBlueClubTransfers,
    },
    data() {
      return {
        cols: [
          { i18n: 'th.date', align: 'center' },
          { i18n: 'th.amount', align: 'center' },
        ]
      }
    },
    computed: {
      ...mapGetters(['clubTransfers'])
    },
    methods: {
      ...mapActions(['getClubTransfers']),
      async onApply({ min, max }) {
        await this.getClubTransfers({ min, max });
      },
    },
  }
</script>

<style scoped>
#container {
  margin-top: 35px;
}
</style>
